import { useWindowDimensions } from "@/components/hooks/use-window-dimension/";
import {
  Dialog,
  DialogContent,
  View,
  DialogHeader,
  DialogTitle,
  Button,
} from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import type { Icon } from "@/components/shared/icons";
import { Warning } from "@/components/shared/icons";
import { Divider } from "../divider";
import { Typography } from "../typography";

export const ConfirmationDialog = ({
  title = "Confirmation",
  description,
  open,
  icon: Icon = Warning,
  iconClassName = "color-warning",
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  loading = false,
}: {
  title?: string;
  description: string;
  open: boolean;
  icon?: Icon;
  iconClassName?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}) => (
  <Dialog open={open} onOpenChange={onCancel}>
    <DialogContent className="w-[343px] max-w-full rounded-lg">
      <View>
        <DialogHeader className="flex flex-row justify-between gap-2">
          <View className="flex flex-row items-center gap-1">
            <Icon size={24} weight="fill" className={iconClassName} />
            <DialogTitle>{title}</DialogTitle>
          </View>
          {useWindowDimensions().isDesktop && (
            <IconButton
              variant="secondary"
              color="foreground"
              size="md"
              iconName="x"
              onClick={onCancel}
            />
          )}
        </DialogHeader>
        <Divider className="py-1" />
      </View>

      <Typography variant="body-md">{description}</Typography>
      <Button
        variant="primary"
        color="CTA"
        rounded="full"
        className="mt-4"
        onClick={onConfirm}
        children={confirmText}
        loading={loading}
      />

      <Button
        variant="secondary"
        color="CTA2"
        rounded="full"
        onClick={onCancel}
        children={cancelText}
      />
    </DialogContent>
  </Dialog>
);
